<template>
  <v-btn v-bind="{ ...$attrs }" :rounded="rounded" v-on="$listeners">
    <slot>
      <span v-if="t" v-t="t" />
    </slot>
  </v-btn>
</template>

<script>
export default {
  props: {
    t: {
      type: String,
      default: null,
    },
    rounded: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style></style>
